import { createContext, useEffect, useState, useCallback } from "react";
import { getErrorMessageFromError } from "../../components/ErrorMessage";
import { useApp } from "../../hooks/useApp";
import { CustomerStatusDto } from "../../model/CustomerStatusDto";
import { SVCustomerStatusRequest, SVCustomerStatusDelete, SVCustomerStatusSaveRequest, SVCustomerStatusUpdatedRequest } from "../../services/customerStatus/CustomerStatusService";

const CustomerStatusDataContext = createContext();

const CustomerStatusDataContextProvider = ({ children }) => {
    const [listCustomerStatus, setListCustomerStatus] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedCustomerStatus, setSelectedCustomerStatus] = useState(null);
    const [customerStatusIdToDelete, setCustomerStatusIdToDelete] = useState(0);
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);

    const { setSuccessMsg,
        setErrorMsg,
        setLoading,
        messageUser,
        loading,
        authenticate,
        authInfo,
        isAdmin,
    } = useApp();
    const [isFirstRenderRowsPerPage, setIsFirstRenderRowsPerPage] = useState(true);
    const [page, setPage] = useState(0);
    const [totalItems, setTotalItems] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    
    const handleChangePage = (event, newPage) => {
        setPage(newPage);        
    };
    
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
    };

    useEffect(() => {
        if(authenticate && authInfo)
            setTimeout(
                () => loadCustomerStatus(),
                100
            );
    },[page, authenticate, authInfo]);

    useEffect(() => {
        if(isFirstRenderRowsPerPage)
            setIsFirstRenderRowsPerPage(false);
        else{
            if(page == 0)
                setTimeout(
                    () => loadCustomerStatus(), 
                    100
                );
            else
                setPage(0);
        }
    },[rowsPerPage]);

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedCustomerStatus(null)
    };

    const onClickActionEditButton = (params) => {
        setSelectedCustomerStatus(params.row);
        handleOpenModal()
    };

    const handleFormSubmit = async (values) => {
        try {
            const input = {
                ...values
            };
            setLoading(true)
            if (values.id) {
                await SVCustomerStatusUpdatedRequest(input);
                setSuccessMsg("Editado con éxito");

            } else {
                await SVCustomerStatusSaveRequest(input);
                setSuccessMsg("Creado con éxito")
            }
            loadCustomerStatus();
            setLoading(false);
            handleCloseModal();
        } catch (error) {
            let errorMessage = getErrorMessageFromError(error);
            if (!errorMessage) {
                errorMessage = "Error desconocido al procesar la solicitud";
            }
            setErrorMsg(errorMessage);
            setLoading(false);
        }
    }

    const loadCustomerStatus = useCallback(async () => {
        // console.log("desde contexts");
        try {
            setLoading(true);
            let responseCustomerStatusList = await SVCustomerStatusRequest(page, rowsPerPage);
            setTotalItems(responseCustomerStatusList.totalElements);
            const customerStatus = responseCustomerStatusList.content.map(customerStatusData => {
                return new CustomerStatusDto(
                    customerStatusData.factor_id,
                    customerStatusData.name,
                    customerStatusData.isParallel ?? false,
                    customerStatusData.stageGroup ?? ''
                );
            })
            setListCustomerStatus(customerStatus)
            setLoading(false)
        } catch (error) {
            setLoading(false)
            const errorMessage = getErrorMessageFromError(error);
            setErrorMsg(errorMessage)
            setLoading(false);
        }
    }, [page, rowsPerPage, setLoading, setErrorMsg]);

    const openDeleteConfirmation = (customerStatusId) => {
        setCustomerStatusIdToDelete(customerStatusId);
        setShowDeleteConfirmation(true);
    };

    const closeDeleteConfirmation = () => {
        setCustomerStatusIdToDelete(null);
        setShowDeleteConfirmation(false);
    };

    const handleDeleteConfirmed = async () => {
        closeDeleteConfirmation();
        if (customerStatusIdToDelete) {
            await handleDelete(customerStatusIdToDelete);
        }
    };

    const handleDelete = async (customerStatusId) => {
        try {
            setLoading(true)
            await SVCustomerStatusDelete(customerStatusId);
            setSuccessMsg("Eliminado con éxito")
            loadCustomerStatus();
            setLoading(false)
        } catch (error) {
            let errorMessage = getErrorMessageFromError(error);
            if (!errorMessage) {
                errorMessage = "Error desconocido al procesar la solicitud";
            }
            setErrorMsg(errorMessage);
            setLoading(false);
        }
    };

    return (
        <CustomerStatusDataContext.Provider value={{
            listCustomerStatus,
            loadCustomerStatus,
            loading,
            messageUser,
            handleOpenModal,
            handleCloseModal,
            isModalOpen,
            onClickActionEditButton,
            setSelectedCustomerStatus,
            selectedCustomerStatus,
            showDeleteConfirmation,
            openDeleteConfirmation,
            closeDeleteConfirmation,
            handleDeleteConfirmed,
            handleFormSubmit,
            handleDelete,
            page, 
            setPage,
            rowsPerPage, 
            handleChangePage,
            handleChangeRowsPerPage,
            totalItems
        }}>
            {children}
        </CustomerStatusDataContext.Provider>
    )
}

export { CustomerStatusDataContext,CustomerStatusDataContextProvider };
